import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';

export interface AiAgentProfile {
  name: string;
  avatar_url: string;
}

/**
 * Shared hook for the AI agent profile (name + avatar).
 * Used by the settings page and the nav avatar launcher.
 * Stale for 5 minutes to avoid refetching on every nav render.
 */
export function useAiAgentProfile(options: { enabled?: boolean } = {}) {
  return useQuery<AiAgentProfile>({
    enabled: options.enabled ?? true,
    queryKey: ['ai-agent-profile'],
    queryFn: () =>
      api.aiAgent.getProfile().then(
        (r: any) => r.data?.data ?? r.data ?? { name: '', avatar_url: '' },
      ),
    staleTime: 5 * 60_000,
  });
}
